<template>
  <v-container>
    <app-loading :loading="loading">
      <div>
        <app-header :buttonAction="action" backButton :backAction="backAction">
          <template v-slot:title>{{ data.title }}</template>
          <template v-slot:subtitle>{{ data.subtitle }}</template>
        </app-header>
        <app-explanation class="mt-5">
          <template v-slot:body>{{ data.description }}</template>
        </app-explanation>
        <app-audio-player class="mt-7" :src="data.lesson_file" />
      </div>
    </app-loading>
    <v-card class="radius py-5 px-9 mt-7 shadow">
      <app-rich-text ref="editor" :body="JSON.parse(data.rich_text)">
        <template v-slot:title>{{ data.rich_title }}</template>
      </app-rich-text>
    </v-card>
  </v-container>
</template>
<script>
import RichText from "@/components/Lessons/Lesson/components/RichText";
import Header from "@/components/Lessons/Lesson/components/Header.vue";
import Explanation from "@/components/Lessons/Lesson/components/Explanation";
import AudioPlayer from "@/components/Lessons/Lesson/components/AudioPlayer";
import Loading from "@/components/Loading.vue";
import { getLessonAudioTranscript, patchLessonProgress } from "@/api/api";

export default {
  components: {
    appRichText: RichText,
    appHeader: Header,
    appExplanation: Explanation,
    appAudioPlayer: AudioPlayer,
    appLoading: Loading,
  },
  data() {
    return {
      data: {
        rich_text: '{"type": "doc","content": []}',
      },
      loading: true,
    };
  },
  methods: {
    action() {
      this.$emit("next-step");
      const progress = this.$store.getters["progress/lesson"];
      if (!progress.teach_progress.audio_transcript_step) {
        progress.teach_progress.audio_transcript_step = true;
        patchLessonProgress(progress).then((response) => {
          this.$store.commit("progress/lesson", response.data);
        });
      }
    },
    backAction() {
      this.$emit("prev-step");
    },
  },
  async created() {
    this.loading = true;
    const response = await getLessonAudioTranscript(
      this.$store.getters["lesson/teacher_lesson"].audio_transcript_step,
    );
    this.data = response.data;
    this.loading = false;
  },
};
</script>
